import { Component, OnDestroy, OnInit } from "@angular/core";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { LogClass, Logger } from "../../logger";
import { NavigationService } from "../../services";

@Component({
    selector: "circ-new-from-prepared",
    templateUrl: "./new-from-prepared.component.html",
    styleUrls: ["./new-from-prepared.component.scss"],
    standalone: false
})
@LogClass({ source: "NewFromPreparedComponent" })
export class NewFromPreparedComponent implements OnInit, OnDestroy {
  private subscriptions = new SubSink();
  private logger: Logger;

  constructor(
    private navigate: NavigationService,
    private templateFacade: TemplateFacade
  ) {
    this.logger.debug("ctor");
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.templateFacade.createNewForPrepareId().subscribe(
      (circId) => {
        this.navigate.toCirculation(circId);
      },
      (error) => {
        this.logger.error("Error creating prepared Circulation", error);
        this.navigate.toError(error as string);
      }
    );
  }
}
